import PropTypes from 'prop-types';

export default function If({ test, children }) {
  return test && children;
}

If.propTypes = {
  test: PropTypes.bool.isRequired,
};
